<template>
    <signView :viewType="1" :showTop="false">
        <template  v-slot:mainCenter>
            <div class="login_box">
                <div class="login_item">
                    <div class="login_from">
                        <h1 class="centerText bold_primaryText" style="margin-bottom:50px">Set new password</h1>
                        <el-input autocomplete="new-password" type="password" maxlength="16" v-model="password" :class="{'is-error':emptyEmail}" @blur="valid(1)" class="myLogin_input" placeholder="New Password"></el-input>
                        <el-input autocomplete="new-password" type="password" maxlength="16" v-model="password1" :class="{'is-error':emptyPassword}" @blur="valid(2)" class="myLogin_input marginTB_input" placeholder="Re-enter Password"></el-input>
                        <div class="default_Btn" :class="{'loading_btn':loading}" @click="setNewPassword">Save new password
                            <i v-show="loading" class="el-icon-loading my_loading_icon"></i>
                        </div>
                    </div>
                    <img src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/4c70d3514be74e4e8ba7c4b79d089e44.png" class="login_icon" alt="">
                </div>
            </div>
        </template>
    </signView>
</template>

<script>
import api from '../../api/login'
import md5 from 'js-md5'
import signView from '../common/sign-view.vue'
export default {   
    components:{signView},
    data() {
        return {
            isSuccessFormat:true,
            loading:false,
            email:'',
            password:'',
            password1:'',
            emptyEmail:false,
            emptyPassword:false,
            sessionId:''
        }
    },
    methods: {
        valid(key){
            switch (key) {
                case 1:
                    this.emptyEmail = this.password?false:true
                    /*if(!this.emptyEmail){
                        this.emptyEmail = false
                        this.isSuccessFormat = Utils.isEmail(this.email)
                    }*/
                    break;
                case 2:
                    this.emptyPassword = this.password1?false:true
                    break;
            }
        },
        setNewPassword(){
            if(this.loading) return
            this.valid(1)
            this.valid(2)
            if(this.emptyEmail||this.emptyPassword) return
            if(this.password.split('').length<8||this.password.split('').length>16){
                Utils.alert('','Please enter a password of 8-16 digits','error')
                return
            }
            if(this.password!==this.password1){
                Utils.alert('','The 2 passwords entered are not the same','error')
                this.password = ''
                this.password1 = ''
                return
            }
            this.loading = true
            // const pat = {
            //     email:this.email,
            //     password:md5(this.password),
            //     sessionId:this.sessionId
            // }
            const pat = new FormData()
            pat.append('email',this.email)
            pat.append('password',md5(this.password))
            pat.append('sessionId',this.sessionId)
            api.updatePassword(pat,res=>{
                const {code,message} = res.data;
                this.loading = false
                if(code == 200){
                    Utils.alert('',message,'success')
                    this.$router.push('/login')
                }else{
                    Utils.alert('',message,'error')
                }
            })
        }
    },
    mounted() {
        this.email = this.$route.query.email
        this.sessionId = this.$route.query.sessionId
    }
}
</script>

<style lang="scss" scoped>
.login_box{
    min-height: calc(100vh - 128px);
    padding-top: 77px;
    // overflow: hidden;
    .login_item{
        display: flex;
        width: 1220px;
        margin: 0 auto;
        .login_from{
            width: 445px;
            min-width: 445px;
            margin-top: 156px;
            .marginTB{
                opacity: 1;
                margin: 20px 0 30px 0;
            }
            .marginTB_input{
                margin: 16px 0 24px 0;
            }
            .forget_password{
                text-align: center;
                text-decoration: underline;
                cursor: pointer;
                font-size: 14px;
                font-family: Assistant-Bold, Assistant;
                font-weight: bold;
                color: #F8A4AE;
                line-height: 16px;
                margin-top: 20px;
            }
            .login_foot{
                font-size: 15px;
                opacity: 0.8;
                margin-top: 24px;
                line-height: 18px;
            }
            /deep/{
                .myLogin_input{
                    height: 55px;
                    .el-input__inner{
                        height: 55px;
                        line-height: 55px;
                        background: #4e4c4a;
                        border-color: #4e4c4a;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .login_icon{
            margin-left: auto;
            width: 740px;
            height: 722px;
            margin-right: -89px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/sign/update-password.vue